<template>
  <div class="row px-1 pr-md-0 pb-2">
    <div v-if="acc.image_uri" class="col-12 col-md-4 mb-2 mb-md-0 c-card-img">
      <div class="c-card-img-container">
        <img v-if="acc.image_uri" :src="acc.image_uri" :alt="acc.manufacturer_code" class="card-img-top">
      </div>
    </div>
    <div class="col" :class="[acc.image_uri ? 'pl-1 pr-2' : 'px-2']">
      <h5 class="mb-2">{{acc.name}}</h5>
      <div class="mb-2">{{acc.description}}</div>
      <div class="mb-1">
        <template v-if="dealer !== 'none'">
          <span  v-for="(value, key) in acc.dealer_prices" :key="key">
            <span v-if="dealer === key" class="text-green">({{ value }} €) </span>
          </span>
        </template>
        {{dealerPrice(acc.price, acc.dealer_prices)}}
      </div>
      <div class="mb-1">
        Tuoteryhmä: {{acc.category}}<br>
        Tuotekoodi: {{acc.manufacturer_code}}<br>
        <span v-if="acc.package_code">Pakettikoodi: {{acc.package_code}}</span>
      </div>
      <div v-if="model === 'all'">
        <span v-for="(item, index) in acc.cars" :key="index" class="badge bg-grey-paragraph text-white border c-mr-half">{{index}}</span>
      </div>
      <div v-if="acc.installed_by !== 'DEALER'" class="mt-1 support-text"><i class="fa fa-info-circle text-red"></i>&nbsp; Saatavilla vain uuden auton tilauksen yhteydessä</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OpenAccessory',
  props: {
    acc: Object,
    model: String
  },

  computed: {
    ...mapGetters({
      dealer: 'getDealer'
    })
  },

  methods: {
    dealerPrice: function (p, dp) {
      if (this.dealer !== 'none') {
        if (dp[this.dealer]) {
          return dp[this.dealer] + ' €'
        } else {
          return p + ' €'
        }
      } else {
        return p + ' €'
      }
    }
  }
}
</script>

<style scoped>
.c-card-img {
  position: relative;
  width: 100%;
}

.c-card-img:after {
  content: "";
  display: block;
  padding-bottom: 100%; /* aspect-ratio 1:1 */
}

.c-card-img-container {
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
  text-align: center;
}

.card-img-top {
  padding: 0 1em;
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
}
</style>
